import { BadgeStatus } from "@sabre/spark-react-core/types";
import { lazy } from "react";

// Define constants for URLs
const GOOGLE_URL = "http://www.google.com";

// Define lazy-loaded components
const DefaultLayout = lazy(() => import("../layouts/Default"));
const ExperimentPage = lazy(() => import("../pages/Experiment"));
// const ExpntAddEditPage = lazy(() => import("../pages/Experiment/AddEditPage"));
const ContextModelPage = lazy(() => import("../pages/ContextModel"));
const ContextPage = lazy(() => import("../pages/Context"));

export const config = {
  AppConfig: {
    id: "wlv_experiment_admin",
    title: "Experimentation Admin",
    locales: ["en-US"],
    defaultLocale: "en-US",
    logo: {
      header: "",
      footer: "",
    },
  },
  HeaderConfig: {
    fixed: true,
    navigationItems: [
      {
        label: "Experiments",
        link: "#/",
        parent: "#/",
      },
      // {
      //   label: "Create Experiment",
      //   link: "#/experiments/create",
      //   parent: "experiments",
      //   hidden: true
      // },
      // {
      //   label: "Edit Experiment",
      //   link: "#/experiments/edit",
      //   hidden: true
      // },
      {
        label: "Context Models",
        link: "#/contextmodels",
        parent: "#/contextmodels",
      },
      {
        label: "Contexts",
        link: "#/contexts",
        parent: "#/contexts",
      },
      {
        label: "Analyze result",
        link: "#/analyzeresults",
        parent: "#/analyzeresults",
      },
    ],
  },
  FooterConfig: {
    navigations: [],
    signature: "",
    yearRange: new Date().getFullYear(),
    links: [
      // {
      //   text: "Legal Policy",
      //   url: GOOGLE_URL,
      // },
      // {
      //   text: "Support",
      //   url: GOOGLE_URL,
      // },
      // {
      //   text: "Contact Us",
      //   url: GOOGLE_URL,
      // },
    ],
    social: {
      facebook: "https://www.facebook.com/SabreCorporation/",
      instagram: "https://www.instagram.com/sabrespark/?hl=en",
      linkedin: "https://www.linkedin.com/company/sabre-corporation",
      twitter: "https://twitter.com/Sabre_Corp",
      youtube: "https://www.youtube.com/user/SabreNewsTV",
    },
  },
  LayoutConfig: {
    default: {
      component: DefaultLayout,
      isProtected: true,
      header: {},
      content: {},
      footer: {},
    },
  },
  RouteConfig: [
    {
      path: "/",
      label: "Experiments",
      index: true,
      exact: true,
      isActive: true,
      layout: "default",
      page: "experiments",
    },
    {
      path: "/experiments/create",
      label: "Experiment Setup",
      index: false,
      exact: true,
      isActive: true,
      layout: "default",
      page: "experiment_create",
    },
    {
      path: "/experiments/edit",
      label: "Experiment Setup",
      index: false,
      exact: true,
      isActive: true,
      layout: "default",
      page: "experiment_edit",
    },
    {
      path: "/contexts",
      label: "Contexts",
      index: true,
      exact: true,
      isActive: true,
      layout: "default",
      page: "contexts",
    },
    {
      path: "/contextmodels",
      label: "Context Models",
      index: true,
      exact: true,
      isActive: true,
      layout: "default",
      page: "contextmodels",
    },
    {
      path: "/analyzeresults",
      label: "AnalyzeResults",
      index: false,
      exact: true,
      isActive: true,
      layout: "default",
      page: "analyzeresults",
    },
  ],
  PageConfig: {
    experiments: {
      id: "experimentation",
      apiUri: "experiments",
      label: "Experiments",
      parent: "",
      component: ExperimentPage,
      actionTypeIcon: false,
      actions: {
        header: {
          typeIcon: false,
          actions: [
            {
              id: "experiment_new",
              label: "Create Experiment",
              type: "icon",
              tooltip: "Add New",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
          ],
        },
        content: {
          typeIcon: false,
          actions: [
            {
              id: "experiment_status",
              label: "Status",
              type: "icon",
              tooltip: "Filter Status",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {
                handler: "",
                items: [
                  { key: "all", label: "Show all" },
                  { key: "active", label: "Show active" },
                  { key: "inactive", label: "Show inactive" },
                  { key: "created", label: "Show created" },
                ],
              },
            },
            {
              id: "experiment_clone",
              label: "Clone",
              disabled: false,
              type: "icon",
              tooltip: "Clone experiment",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
            {
              id: "experiment_delete",
              label: "Delete",
              type: "icon",
              tooltip: "Manage Columns",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
          ],
        },
      },
      tables: {
        tbl_id_1: {
          id: "experiment_list",
          dataKey: "mlOptimizations",
          styles: {
            row: {},
            column: {},
          },
          actions: [
            {
              icon: "spark-icon-data-line",
              label: "Chart",
              style: { height: "2rem", width: "2rem", fontSize: "1.35rem", padding: 0 },
            },
          ],
          columns: [
            { Header: "Name", accessor: "name", style: { width: "10%" }, tooltip: true },
            {
              Header: "Type",
              accessor: "optimizationType",
              style: { width: "20%" },
              tooltip: true,
            },
            {
              Header: "Description",
              accessor: "description",
              style: { width: "14%" },
              tooltip: true,
            },
            { Header: "Priority", accessor: "priority", style: { width: "5%" } },
            { Header: "Created By", accessor: "metadata.createdBy", style: { width: "12%" } },
            { Header: "Modified By", accessor: "metadata.updatedBy", style: { width: "12%" } },
            {
              Header: "Effective",
              accessor: "effectiveDate",
              getValue: (val: any) => {
                if (!val) return "";
                if (typeof val === "object" && val.month && val.day && val.year) {
                  return `${val.month}-${val.day}-${val.year}`;
                }
              },
              style: { width: "8%" },
            },
            {
              Header: "Modified",
              accessor: "metadata.updateTimestamp",
              getValue: (val: string) => val?.split("T")[0],
              style: { width: "8%" },
            },
            {
              Header: "Status",
              accessor: "state",
              getValue: (val: string) => val?.split("_")[1],
              style: { width: "12%" },
              custom: {
                component: "badge",
                types: {
                  inactive: BadgeStatus.NEUTRAL,
                  active: BadgeStatus.SUCCESS,
                  created: BadgeStatus.WARNING,
                },
              },
            },
          ],
        },
      },
      forms: {},
      tabs: {},
    },
    contextmodels: {
      id: "contextmodels",
      apiUri: "contextmodels",
      label: "Context Models",
      parent: "configuration",
      component: ContextModelPage,
      actionTypeIcon: false,
      actions: {
        header: {
          typeIcon: false,
          actions: [
            {
              id: "contextmodel_new",
              label: "Create Context Model",
              type: "icon",
              tooltip: "Add New",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
          ],
        },
        content: {
          typeIcon: false,

          actions: [
            {
              id: "contextmodel_status",
              label: "Status",
              type: "icon",
              tooltip: "Filter Status",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {
                handler: "",
                items: [
                  { key: "all", label: "Show all" },
                  { key: "in-use", label: "Show in use" },
                  { key: "not-in-use", label: "Show not in use" },
                ],
              },
            },
            {
              id: "contextmodel_clone",
              label: "Clone",
              type: "icon",
              tooltip: "Clone Context Model",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
            {
              id: "contextmodel_delete",
              label: "Delete",
              type: "icon",
              tooltip: "Manage Columns",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
          ],
        },
      },
      tables: {
        tbl_id_1: {
          id: "contextmodel_list",
          dataKey: "contextModels",
          styles: {
            row: {},
            column: {},
          },
          columns: [
            { Header: "Name", accessor: "name", style: { width: "15%" }, tooltip: true },
            {
              Header: "Description",
              accessor: "description",
              style: {
                width: "37%",
              },
              tooltip: true,
            },
            {
              Header: "Status",
              accessor: "used",
              getValue: (val: string) => (val ? "In use" : ""),
              custom: {
                component: "badge",
                types: {
                  "in use": BadgeStatus.WARNING,
                },
              },
              style: { width: "7%" },
            },
            { Header: "Created By", accessor: "metadata.createdBy", style: { width: "15%" } },
            { Header: "Modified By", accessor: "metadata.updatedBy", style: { width: "15%" } },
            {
              Header: "Modified",
              accessor: "metadata.updateTimestamp",
              getValue: (val: string) => val?.split("T")[0],
              style: { width: "8%" },
            },
          ],
        },
      },
      forms: {},
      tabs: {},
    },
    contexts: {
      id: "contexts",
      apiUri: "contexts",
      label: "Contexts",
      parent: "configuration",
      component: ContextPage,
      actionTypeIcon: false,
      actions: {
        header: {
          typeIcon: false,
          actions: [
            {
              id: "context_new",
              label: "Create Context",
              type: "icon",
              tooltip: "Add New",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
          ],
        },
        content: {
          typeIcon: false,
          actions: [
            {
              id: "context_status",
              label: "Status",
              type: "icon",
              tooltip: "Filter Status",
              icon: "math-add-circle spark-icon--md",
              iconStyle: "fill",
              list: {
                handler: "",
                items: [
                  { key: "all", label: "Show all" },
                  { key: "in-use", label: "Show in use" },
                  { key: "not-in-use", label: "Show not in use" },
                ],
              },
            },
            {
              id: "context_clone",
              label: "Clone",
              type: "icon",
              tooltip: "Clone Context",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              list: {},
            },
            {
              id: "context_delete",
              label: "Delete",
              type: "icon",
              tooltip: "Manage Columns",
              icon: "sliders spark-icon--md",
              iconStyle: "fill",
              handler: "",
              list: {},
            },
          ],
        },
      },
      tables: {
        tbl_id_1: {
          id: "context_list",
          dataKey: "contexts",
          styles: {
            row: {},
            column: {},
          },
          actions: [
            {
              icon: "spark-icon-data-line",
              label: "Chart",
              style: { height: "2rem", width: "2rem", fontSize: "1.35rem", padding: 0 },
            },
          ],
          columns: [
            { Header: "Name", accessor: "name", tooltip: true, style: { width: "15%" } },
            {
              Header: "Description",
              accessor: "description",
              tooltip: true,
              style: { width: "34%" },
            },
            {
              Header: "Status",
              accessor: "used",
              getValue: (val: string) => (val ? "In use" : ""),
              custom: {
                component: "badge",
                types: {
                  "in use": BadgeStatus.WARNING,
                },
              },
              style: { width: "7%" },
            },
            { Header: "Created By", accessor: "metadata.createdBy", style: { width: "15%" } },
            { Header: "Modified By", accessor: "metadata.updatedBy", style: { width: "15%" } },
            {
              Header: "Modified",
              accessor: "metadata.updateTimestamp",
              getValue: (val: string) => val?.split("T")[0],
              style: { width: "8%" },
            },
          ],
        },
      },
      forms: {
        add: {
          id: "",
          title: "Add a context",
          display: "overlay",
          description: "",
          elements: [
            {
              title: "groupTitle",
              properties: [
                [
                  {
                    label: "Context name",
                    type: "text",
                    placeholder: "",
                    validation: "",
                    align: "",
                  },
                ],
                [
                  {
                    label: "Description",
                    type: "text",
                    placeholder: "",
                    validation: "",
                    align: "",
                  },
                ],
              ],
            },
            {
              title: "Assign context feature",
              properties: [
                [
                  {
                    label: "Context feature type",
                    type: "select",
                    placeholder: "",
                    validation: "",
                    align: "",
                  },
                ],
              ],
            },
          ],
          actions: [
            [
              { label: "", type: "", placeholder: "", validation: "", align: "" },
              { label: "", type: "", placeholder: "", validation: "", align: "" },
              { label: "", type: "", placeholder: "", validation: "", align: "" },
            ],
          ],
        },
      },
      tabs: {},
    },
    analyzeresults: {
      id: "analyzeresult",
      label: "Analyze Results",
      parent: "",
      component: lazy(() => import(`../pages/AnalyzeResult`)),
      actionTypeIcon: false,
      actions: {
        header: {},
        content: {},
      },
      tables: {},
      forms: {},
      tabs: {},
    },
  },
};
